import {
  Button,
  Container,
  Fab,
  makeStyles,
  Modal,
  Tooltip,
} from "@material-ui/core";
// import Files from "react-files";

// import { getAllFamilies, getAllSubFamilies } from "../reduxSaga/actions";
import { Add as AddIcon } from "@material-ui/icons";
import React, { useState } from "react";
// import MuiAlert from "@material-ui/lab/Alert";
// import { useDispatch, useSelector } from "react-redux";
// import axios from "axios";
// import Blob from "blob";
// import FormData from "form-data";
// import {
//   addNewCategory,
//   setBrandNotificationState,
// } from "../reduxSaga/actions";
// import { Autocomplete } from "@material-ui/lab";
import PurchaseOrder from "../components/tape/exit/PurchaseOrder";
import { PDFViewer } from "@react-pdf/renderer";

const useStyles = makeStyles((theme) => ({
  fab: {
    position: "fixed",
    bottom: 20,
    right: 20,
  },
  container: {
    borderRadius: 10,
    boxShadow: "0 3px 5px 2px rgba(18,131,255,0.87)",
    width: 1000,
    height: 650,
    backgroundColor: "white",
    position: "absolute",
    top: -30,
    bottom: 0,
    left: 0,
    right: 0,
    margin: "auto",
    [theme.breakpoints.down("sm")]: {
      width: "100vw",
      height: "100vh",
      top: 0,
    },
  },

  familyContainer: {
    marginBottom: theme.spacing(0),
    marginTop: theme.spacing(0),
    display: "flex",
    justifyContent: "space-between",
  },
  form: {
    padding: theme.spacing(0),
  },
  item: {
    marginBottom: theme.spacing(0),
    marginLeft: theme.spacing(-3.2),
    marginTop: theme.spacing(0),
  },

  cancelAndAddButtom: {
    marginBottom: theme.spacing(0),
    marginTop: theme.spacing(0),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  input: {
    "&::placeholder": {
      fontStyle: "italic",
    },
  },
}));

// function Alert(props) {
//   return <MuiAlert elevation={6} variant="filled" {...props} />;
// }

const MyPdfViewerExitTape = ({ tape, setOnShowExitTape }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(true);

  const onCancelButtonHandler = () => {
    setOpen(false);
    setOnShowExitTape(false);
  };

  return (
    <>
      <Tooltip title="Add" aria-label="add" onClick={() => setOpen(true)}>
        <Fab color="primary" className={classes.fab}>
          <AddIcon />
        </Fab>
      </Tooltip>
      <Modal open={open}>
        <Container className={classes.container}>
          <form className={classes.form} autoComplete="off">
            <div className={classes.item}>
              <PDFViewer width="1000" height="600" className="app">
                <PurchaseOrder invoice={tape} />
              </PDFViewer>
            </div>

            <div className={classes.cancelAndAddButtom}>
              <Button
                variant="outlined"
                color="primary"
                onClick={onCancelButtonHandler}
              >
                Cancel
              </Button>
            </div>
          </form>
        </Container>
      </Modal>
    </>
  );
};

export default MyPdfViewerExitTape;
